import { UPDATE_LOGIN_RESULT } from './login.constants'

export const initialState = {
  accessToken: null,
  idToken: null,
  refreshToken: null,
  email: null,
}

export const loginReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_LOGIN_RESULT:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        idToken: action.payload.idToken,
        refreshToken: action.payload.refreshToken,
        email: action.payload.email,
      }
    default:
      return state
  }
}
